import { render, staticRenderFns } from "./capital.vue?vue&type=template&id=6c197c3e&scoped=true"
import script from "./capital.vue?vue&type=script&lang=js"
export * from "./capital.vue?vue&type=script&lang=js"
import style0 from "./capital.vue?vue&type=style&index=0&id=6c197c3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c197c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c197c3e')) {
      api.createRecord('6c197c3e', component.options)
    } else {
      api.reload('6c197c3e', component.options)
    }
    module.hot.accept("./capital.vue?vue&type=template&id=6c197c3e&scoped=true", function () {
      api.rerender('6c197c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/capital.vue"
export default component.exports